import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import WhoWeAre from "@/pages/WhoWeAre";
import Apply from "@/pages/Apply";
import AdminLogin from "@/pages/admin/AdminLogin";
import SetPassword from "@/pages/admin/SetPassword";
import AdminLayout from "@/pages/admin/AdminLayout";
import Applications from "@/pages/admin/Applications";
import ApplicationDetail from "@/pages/admin/ApplicationDetail";
import AdminSettings from "@/pages/admin/AdminSettings";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/who-we-are" element={<WhoWeAre />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/set-password" element={<SetPassword />} />
          <Route element={<AdminLayout />}>
            <Route path="/admin/applications" element={<Applications />} />
            <Route path="/admin/applications/:id" element={<ApplicationDetail />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
          </Route>
        </Routes>
        <Toaster position="top-center" theme="dark" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
